import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import { cn } from 'shadcn-ui';
import { SeparatorWithTextLayoutProps } from '../types';

import styles from './SeparatorWithText.module.scss';

const MARGIN_CLASSES = {
  small: 'my-[1rem]',
  medium: 'my-[1.4rem]',
  big: 'my-[2.5rem]',
} as const;

function LegacySeparatorWithTextLayoutWeb(props: SeparatorWithTextLayoutProps) {
  const marginSize = props.marginSize || 'medium';

  const classNames = [
    styles.separatorWithText,
    `margin-${marginSize}`,
  ];

  return (
    <div className={classNames.join(' ')}>
      <div className={styles.line}></div>
      <span className={styles.text}>{props.text}</span>
      <div className={styles.line}></div>
    </div>
  );
}

function ShadcnSeparatorWithTextLayoutWeb(props: SeparatorWithTextLayoutProps) {
  const marginSize = props.marginSize || 'medium';

  return (
    <div className={cn('flex w-full items-center', MARGIN_CLASSES[marginSize])}>
      <div className="h-px flex-1 bg-gray-300" />
      <span className="whitespace-nowrap px-4 text-sm uppercase text-gray-300">
        {props.text}
      </span>
      <div className="h-px flex-1 bg-gray-300" />
    </div>
  );
}

export default function SeparatorWithTextLayoutWeb(props: SeparatorWithTextLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnSeparatorWithTextLayoutWeb {...props} />;
  } else {
    return <LegacySeparatorWithTextLayoutWeb {...props} />;
  }
}
